






























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { isElectronEnv } from "../../../utils/is-electron-env";
import {
  IPC_GET_EXPORT_CACHE_SIZE,
  IPC_CLEAN_EXPORT_CACHE,
  IPC_OPEN_EXPORT_CACHE_DIR,
} from "../../../../shared/ipc-events/invokables";

@Component
export default class ExportCacheManage extends Vue {
  private sizeCalculated = false;
  private size = 0;
  private removing = false;

  mounted() {
    if (isElectronEnv() && window["ipcRenderer"]) {
      this.calcCacheSize();
    }
  }

  get loading(): boolean {
    return !this.sizeCalculated || this.removing;
  }

  get disable(): boolean {
    return this.loading || this.size === 0;
  }

  get readableSize(): string {
    const { size } = this;
    const unit = 1000;
    const kb = size / unit;
    if (kb < unit) return `${kb.toFixed(2)}KB`;
    const mb = kb / unit;
    if (mb < unit) return `${mb.toFixed(2)}MB`;
    const gb = mb / unit;
    return `${gb.toFixed(2)}GB`;
  }

  async calcCacheSize() {
    const size = await window["ipcRenderer"].invoke(IPC_GET_EXPORT_CACHE_SIZE);
    this.size = size;
    this.sizeCalculated = true;
  }

  async clean() {
    if (!isElectronEnv() || !window["ipcRenderer"]) return;
    this.removing = true;
    const cleanRes = await window["ipcRenderer"].invoke(IPC_CLEAN_EXPORT_CACHE);
    this.sizeCalculated = false;
    await this.calcCacheSize();
    console.log(cleanRes);
    this.removing = false;
  }

  async openCacheDir() {
    if (!isElectronEnv() || !window["ipcRenderer"]) return;
    window["ipcRenderer"].invoke(IPC_OPEN_EXPORT_CACHE_DIR);
  }
}
